module.exports = __webpack_public_path__ + "img/2-1.bc3ecf8a.jpg";